import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiError } from "@/lib/api";
import AuthShell from "@/components/auth/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell eyebrow="Account recovery" title="Forgot your password?" subtitle="Enter your account email and we'll send you a secure reset link.">
      {sent ? (
        <div className="panel p-6" data-testid="forgot-password-sent">
          <MailCheck className="h-8 w-8 text-emerald-400" />
          <p className="mt-4 text-slate-200">If an account exists for <span className="font-mono">{email}</span>, a reset link is on its way. It expires in 1 hour.</p>
          <Link to="/login" className="btn-ghost mt-6 w-full" data-testid="forgot-back-to-login">Back to log in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
          <div className="space-y-2">
            <Label htmlFor="forgot-email">Email</Label>
            <Input id="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field" data-testid="forgot-email-input" />
          </div>
          {error && <p className="rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400" data-testid="forgot-error">{error}</p>}
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="forgot-submit-button">{busy ? "Sending..." : "Send reset link"}</button>
          <p className="text-center text-sm text-slate-400"><Link to="/login" className="text-emerald-400 hover:underline">Back to log in</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
